import { render } from "./CustomerDetailContentLoader.vue?vue&type=template&id=45999d88&scoped=true&ts=true"
import script from "./CustomerDetailContentLoader.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailContentLoader.vue?vue&type=script&lang=ts"

import "./CustomerDetailContentLoader.vue?vue&type=style&index=0&id=45999d88&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45999d88"]])

export default __exports__